import React, { memo, useMemo } from 'react';
import { useFormikContext } from 'formik-2';
import PropTypes from 'prop-types';
import css from './WizardEditor.css';
import { ListItemsContainer } from '../../../components/partials';
import { getSectionsListItems } from './sectionsConfig';
import { TEST_WIZARD_STEPS, WIZARD_DISTRIBUTION } from './consts';
import { AUDIENCE_ABTESTING_STATUS } from '../tableUtils';

const WizardEditor = ({
    activeStepIndex,
    onPrevClick,
    onNextClick,
    submitData,
    onStepClick,
    onDraftClick,
    distributionsData,
}) => {
    const { values } = useFormikContext();
    const disabledItems = useMemo(() => {
        const nonEditableStatuses = [
            AUDIENCE_ABTESTING_STATUS.LIVE,
            AUDIENCE_ABTESTING_STATUS.COMPLETE,
            AUDIENCE_ABTESTING_STATUS.SCHEDULED,
        ];

        if (nonEditableStatuses.includes(values.status)) {
            return [];
        }

        if (values.status === AUDIENCE_ABTESTING_STATUS.EDIT && activeStepIndex < 2) {
            const draftStepIndex = TEST_WIZARD_STEPS.indexOf(values.draftStep);
            return TEST_WIZARD_STEPS.slice(draftStepIndex + 1);
        }

        switch (activeStepIndex) {
            case 0:
                return [WIZARD_DISTRIBUTION, ...TEST_WIZARD_STEPS.slice(1)];
            case 1:
                return TEST_WIZARD_STEPS.slice(2);
            default:
                return [];
        }
    }, [activeStepIndex, values.status, values.draftStep]);

    const listItems = useMemo(
        () =>
            getSectionsListItems(onNextClick, onPrevClick, onDraftClick, distributionsData, submitData, disabledItems),
        [onNextClick, onPrevClick, onDraftClick, distributionsData, submitData, disabledItems]
    );

    return (
        <ListItemsContainer
            listItems={listItems}
            isExpandable
            showCheckedIcon
            pageContainerClassName={css.container}
            sectionContentClassName={css.content}
            sectionContentContainerClassName={css.contentSectionContainer}
            sectionListClassName={css.list}
            onClickListItem={id => onStepClick(id)}
            activeItem={TEST_WIZARD_STEPS[activeStepIndex]}
        />
    );
};

WizardEditor.propTypes = {
    activeStepIndex: PropTypes.number,
    onPrevClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired,
    onDraftClick: PropTypes.func.isRequired,
    submitData: PropTypes.shape({
        loading: PropTypes.bool,
        error: PropTypes.bool,
    }),
    onStepClick: PropTypes.func,
    distributionsData: PropTypes.shape({
        allNetworks: PropTypes.arrayOf(
            PropTypes.shape({
                display_name: PropTypes.string,
                name: PropTypes.string,
                isDisabled: PropTypes.bool,
            })
        ),
        internalDistributions: PropTypes.any,
        distributionNetworks: PropTypes.any,
    }),
};

export default memo(WizardEditor);
